/*
 * @Author: zxf
 * @Date: 2021-12-01 15:48:40
 * @LastEditors: zhangqi
 * @LastEditTime: 2024-01-11 17:51:05
 * @Description: 点云捕捉器
 * @FilePath: \neolix-map-sdk\src\snap\SnapPointCloud.js
 */

import * as THREE from "../../libs/three.js/build/three.module.js";
import SnapActor from "./SnapActor";
export default class SnapPointCloud extends SnapActor{
    constructor(options) {
        super(options);
		this.type = 'SnapPointCloud';
    }

    snap(point) {
		const camera = this.scene.getActiveCamera();
		const pointclouds = this.viewer.scene.pointclouds;
        return this.getMousePointCloudIntersection(
			point, camera, this.viewer, pointclouds);
    }

    getMousePointCloudIntersection (mouse, camera, viewer, pointclouds) {
		let renderer = viewer.renderer;
		let nmouse = {
			x: (mouse.x / renderer.domElement.clientWidth) * 2 - 1,
			y: -(mouse.y / renderer.domElement.clientHeight) * 2 + 1
		};

		let pickParams = {};

		pickParams.x = mouse.x;
		pickParams.y = renderer.domElement.clientHeight - mouse.y;
		pickParams.pickClipped = true;
		pickParams.all = true;
    pickParams.pickWindowSize = 10;

		let raycaster = new THREE.Raycaster();
		raycaster.setFromCamera(nmouse, camera);
		let ray = raycaster.ray;

		let selectedPointcloud = null;
		let closestDistance = Infinity;
		let closestIntersection = null;
		let closestPoint = null;
		
		for(let pointcloud of pointclouds){
			let points = pointcloud.pick(viewer, camera, ray, pickParams);
			
			if(!(points && points.length)){
				continue;
			}
      
      // 求平均z值
      let sum = 0;
      for (let i = 0; i < points.length; i++) {
        sum += points[i].position.z;
      }
      let point = points[0];
      point.position.z = sum / points.length;

			let distance = camera.position.distanceTo(point.position);

			if (distance < closestDistance) {
				closestDistance = distance;
				selectedPointcloud = pointcloud;
				closestIntersection = point.position;
				closestPoint = point;
			}
		}

		if (selectedPointcloud) {
			return {
				distance: closestDistance,
				snapPoint: closestIntersection,
				type: 'snapPointCloud'
			};
		} else {
			return null;
		}
	}

	/**
     * 在当前捕捉位置绘制捕捉符号
     * @return {undefined}
     */
	 drawSnapSymbol(point) {
        if (!this.feedback) {
            return;
        }
    }

	/**
     * 绘制当前捕捉的捕捉符号反馈.
     * @return {undefined}
     */
	draw(napResult, mousePoint) {
		super.draw(napResult, mousePoint);
		return false;
    }
}